export default __webpack_public_path__ + "static/media/knopka.25469bd6.PNG";